import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import PropTypes from 'prop-types'

import { Link } from '@material-ui/core'
import BreadcrumbsMui from '@material-ui/core/Breadcrumbs'

import useStyles from './styles'

const Breadcrumbs = ({ breadcrumbs }) =>{
  const classes = useStyles()

  return (
    <BreadcrumbsMui separator="›" aria-label="breadcrumb">
      <Link
        key="home"
        color="primary"
        to="/"
        aria-current="page"
        className={ classes.root }
        component={ RouterLink }
      >
        Home
      </Link>
      {breadcrumbs.map(crumb => (
        <Link
          key={ crumb.key }
          to={ crumb.url }
          aria-current="page"
          className={ crumb.active ? classes.active : classes.root }
          component={ RouterLink }
        >
          {crumb.title}
        </Link>
      ))}
    </BreadcrumbsMui>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array
}

Breadcrumbs.defaultProps = {
  breadcrumbs: []
}

export default Breadcrumbs
